<template>
  <div class="persona-container" :class="profileData.persona_code != null && 'persona-container-added'">
    <div class="title-container">
      <div class="title">Innovator Persona</div>
      <button class="utility" style="outline: none" @click="test=true; openModal = true;" v-if="profileData.persona_code != null && accessProfile">
        <img class="space" src="https://images.avishkaar.cc/misc/profile/utility/retake-icon.png" alt="Retake" />
        <div class="span">Retake Test</div>
      </button>
    </div>
    <div class="no-persona" v-if="profileData.persona_code == null">
      <div class="sub-title">Take this 2-minutes test to understand your innovator persona, your carrer paths and much more!</div>
      <button class="orange-button" @click="test = true; openModal = true;">Take Test</button>
    </div>
    <div class="persona-added scrollbar hide-scrollbar" v-if="profileData.persona_code != null">
      <div class="persona-detail-card persona-type" :class="!accessProfile && 'no-access-profile-filler'">
        <img :src="profileData.persona_result.persona.image" class="persona-detail-avatar persona-type-avatar" alt="Avatar" />
        <div class="sub-title type">My Persona Type</div>
        <div class="title">{{profileData.persona_result.persona.name}}</div>
        <div class="content scrollbar">
         {{profileData.persona_result.persona.description}}
        </div>
      </div>
      <div class="persona-detail-card career-pathway" :class="!accessProfile && 'no-access-profile-filler'">
        <img :src="profileData.persona_result.career.image" class="persona-detail-avatar career-pathway-avatar" alt="Avatar" />
        <div class="sub-title type">My Career Pathway</div>
        <div class="title">{{profileData.persona_result.career.name}}</div>
        <div class="content scrollbar">
         {{profileData.persona_result.career.description}}
        </div>
      </div>
      <div class="persona-detail-card matching-personality" :class="!accessProfile && 'no-access-profile-filler'">
        <img :src="profileData.persona_result.personality.image" class="persona-detail-avatar matching-personality-avatar" alt="Avatar"  />
        <div class="sub-title type">Matching Personality</div>
        <div class="title">{{profileData.persona_result.personality.name}}</div>
        <div class="content scrollbar">
         {{profileData.persona_result.personality.description}}
        </div>
      </div>
    </div>
    <v-dialog v-model="openModal" width="unset" persistent :fullscreen="$vuetify.breakpoint.width < 700 && true">
      <div class="dialog-persona-container" v-if="test">
        <div class="dialog-title-container">
          <div class="title">Personality Test</div>
          <button style="outline: none" @click="test=false; openModal=false;" >
            <img src="https://images.avishkaar.cc/misc/profile/utility/cross-icon.png" alt="Cancel"  />
          </button>
        </div>
        <div class="dialog-form-container" :style="item.visible ? '' : 'display:none'" v-for="(item, index) in questionsData" :key="index">
          <div class="title">
            <strong>{{ index + 1 }}.</strong> {{ item.question }}
          </div>
          <div class="answer-container">
            <div class="answer">
              <input type="radio" class="ans-item" :id="'personaA' + (index + 1)" :value="item.option_1.option_type" v-model="item.value" />
              <label class="ans-item-label" :for="'personaA' + (index + 1)">{{ item.option_1.option }}</label>
            </div>
            <div class="answer">
              <input type="radio" class="ans-item" :id="'personaB' + (index + 1)" :value="item.option_2.option_type" v-model="item.value" />
              <label class="ans-item-label" :for="'personaB' + (index + 1)">{{ item.option_2.option }}</label>
            </div>
          </div>
          <div class="dialog-footer-container">
            <button class="footer-button" :disabled="index == 0"  @click="changeQuestion(false)" :class="index == 0 ? 'back-disabled' : 'back-enabled'" > Back </button>
            <button class="footer-button" :disabled="item.value == ''" @click="changeQuestion(true)" :class="item.value == '' ? 'next-disabled' : 'next-enabled'" > Next </button>
          </div>
        </div>
      </div>
      <div class="success-persona" v-if="success">
        <div class="cancel-success-persona">
          <button style="outline: none" @click="success=false; openModal=false;">
            <img src="https://images.avishkaar.cc/misc/profile/utility/cross-icon.png" alt="Cancel" />
          </button>
        </div>
        <div>
          <div class="success-title">Your Innovator Persona Is Ready!</div>
          <div class="success-content">Your results can be viewed in your profile page</div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Persona",
  props: ["accessProfile"],
  data() {
    return {
      test: false,
      success: false,
      openModal: false,
      count: 0,
    };
  },
  methods: {
    ...mapActions(["fetchPersonaQuestions", "saveUserPersona"]),
    changeQuestion(next) {
      if (next && this.questionsData.length == this.count + 1) {
        this.saveUserPersona({ personaResult: this.personaResult });
        this.success = true;
        this.test = false;
        this.count = 0;
        this.questionsData.map((question) => question.value = null)
      } else this.count = next ? this.count + 1 : this.count - 1;
    },
  },
  computed: {
    ...mapGetters({ profileData: "getUserProfileData" }),
    questionsData: {
      get: function () {
        return this.$store.getters.getPersonaQuestionsData.filter(
          (question, index) => {
            if (index == this.count) question.visible = true;
            else question.visible = false;
            return question;
          }
        );
      },
    },
    personaResult() {
      return this.questionsData.map((question) => question.value);
    },
  },
  created() {
    if (this.$cookies.get("userAccess") !== null) {
      this.fetchPersonaQuestions();
    }
  },
};
</script>

<style lang="scss" scoped>
.persona-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 9%;
  justify-content: center;
  width: 100%;
  height: 60vh;
  .title-container {
    display: flex;
    width: 85%;
    align-items: center;
    justify-content: space-between;
    margin: 1.7% 0;
    .utility {
      display: flex;
      align-items: center;
      justify-content: center;
      .space {
        margin: 0 5px;
      }
      .span {
        font-family: Poppins;
        font-size: 1.25rem;
        font-weight: 500;
        color: #f36f2e;
      }
    }
  }
  .no-persona {
    display: flex;
    margin: 1.7% 0;
    padding: 0 5%;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    width: 85%;
    height: 50%;
    border: 1px solid #cacaca;
    border-radius: 8px;
    .orange-button {
      width: 35%;
      height: 20%;
    }
  }
  .persona-added {
    display: flex;
    margin-top: 1.7%;
    align-items: center;
    justify-content: space-between;
    width: 85%;
    overflow: auto;
    height: 80%;
    border-radius: 8px;
    .persona-detail-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 2%;
      border-radius: 5%;
      flex-shrink: 0;
      width: 32%;
      height: 80%;
      justify-content: flex-start;
      .persona-detail-avatar {
        transform: translateY(-50%);
        width: 125px;
        height: 125px;
        border-radius: 50%;
      }
      .persona-type-avatar {
        border: 1px solid #9bc157;
      }
      .career-pathway-avatar {
        border: 1px solid #fcac31;
      }
      .matching-personality-avatar {
        border: 1px solid #2881c3;
      }
      .type {
        font-weight: 500;
        color: #ffffff;
        transform: translateY(-100%);
      }
      .title {
        font-size: 2rem;
        font-weight: 700;
        color: #ffffff;
      }
      .content {
        font-family: Roboto;
        font-weight: 400;
        color: #ffffff;
        margin: 2% 0;
        height: 50%;
        overflow: auto;
      }
      .content::-webkit-scrollbar {
        width: 0;
        background: transparent;
      }
    }
    .persona-detail-card::before {
      content: "";
      position: absolute;
      margin: 15% 25.3% 0 0;
      width: 17px;
      height: 17px;
      border-radius: 50%;
      background-color: #f36f2e;
      opacity: 0.2;
    }
    .persona-detail-card::after {
      content: "";
      position: absolute;
      margin: 15% 0 0 25.3%;
      width: 17px;
      height: 17px;
      border-radius: 50%;
      background-color: #f36f2e;
      opacity: 0.2;
    }
    .no-access-profile-filler::before {
      margin: 15% 26.55% 0 0;
    }
    .no-access-profile-filler::after {
      margin: 15% 0 0 26.55%;
    }
    .persona-type {
      background-color: #9bc157;
      border: 5px solid #769b33;
    }
    .career-pathway {
      background-color: #fcac31;
      border: 5px solid #cb8418;
    }
    .matching-personality {
      background-color: #2881c3;
      border: 5px solid #0a5a95;
    }
  }
}
.persona-container-added {
  height: 100vh;
}
.dialog-persona-container {
  background: #ffffff;
  height: 80vh;
  width: 60vw;
  .dialog-title-container {
    display: flex;
    align-items: center;
    height: 12%;
    justify-content: space-between;
    padding: 2%;
    border-bottom: 1px solid rgb(0, 0, 0, 0.07);
  }
  .dialog-form-container {
    height: 88%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 1.25rem;
      font-weight: 500;
      text-align: left;
      width: 100%;
      height: 10%;
      padding: 2%;
    }
    .answer-container {
      width: 100%;
      height: 70%;
      padding: 2%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: flex-start;
      .answer {
        display: flex;
        align-items: center;
        flex-basis: 48%;
        width: 48%;
        margin: 2.5% 0;
        height: 25%;
        justify-content: flex-start;
        .ans-item {
          appearance: none;
          position: absolute;
          border-radius: 50%;
          margin: 0 1%;
          width: 15px;
          height: 15px;
          border: 1px solid #505050;
        }
        .ans-item:checked {
          border-color: #f36f2e;
          padding: 2px;
          background-clip: content-box;
          background-color: #f36f2e;
        }
        .ans-item:hover {
          cursor: pointer;
        }
        .ans-item-label {
          font-family: Roboto;
          font-size: 1rem;
          font-weight: 500;
          color: #505050;
          display: flex;
          align-items: center;
          margin: 0;
          text-align: left;
          height: 100%;
          width: 100%;
          justify-content: flex-start;
          border: 1px solid #c4c4c4;
          border-radius: 8px;
        }
        .ans-item-label::before {
          content: "";
          margin-left: 12.5%;
        }
        .ans-item-label::after {
          content: "";
          margin-right: 5%;
        }
        .ans-item-label:hover {
          cursor: pointer;
          border-color: #f36f2e;
        }
        .ans-item:checked ~ .ans-item-label {
          border-color: #f36f2e;
          background-color: #fff3d8;
        }
        .ans-item-label {
          text-transform: capitalize;
        }
      }
    }
    .dialog-footer-container {
      display: flex;
      align-items: center;
      width: 100%;
      height: 20%;
      justify-content: space-between;
      padding: 2%;
      border-top: 1px solid rgb(0, 0, 0, 0.07);
      .footer-button {
        font-family: Roboto;
        outline: 0;
        font-size: 1rem;
        width: 48%;
        height: 96%;
        font-weight: 500;
        box-sizing: border-box;
        border-radius: 30px;
      }
      .back-disabled {
        background: #ffffff;
        border: 1px solid #cecece;
        color: #cecece;
      }
      .next-disabled {
        background: #cecece;
        border: 1px solid #cecece;
        color: #ffffff;
      }
      .back-enabled {
        background: #ffffff;
        border: 1px solid #f36f2e;
        color: #f36f2e;
      }
      .next-enabled {
        background: #f36f2e;
        border: 1px solid #f36f2e;
        color: #ffffff;
      }
    }
  }
}
.success-persona {
  background: url("https://images.avishkaar.cc/misc/profile/images/success-image.png");
  background-size: contain;
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-position: center;
  flex-direction: column;
  height: 80vh;
  display: flex;
  width: 60vw;
  align-items: center;
  padding-bottom: 12%;
  justify-content: space-between;
  .cancel-success-persona {
    display: flex;
    align-items: center;
    padding: 2%;
    width: 99%;
    justify-content: flex-end;
  }
  div {
    .success-title {
      font-family: Poppins;
      font-size: 1.5rem;
      margin: 0.5rem 0;
      font-weight: 600;
      color: #9bc157;
    }
    .success-content {
      font-family: Roboto;
      font-size: 1rem;
      margin: 0.5rem 0;
      font-weight: 400;
      color: #868686;
    }
  }
}
.title {
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 600;
  color: #000000;
}
.sub-title {
  font-family: Poppins;
  font-size: 1.25rem;
  font-weight: 600;
  color: #373737;
}
.content {
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 500;
  color: #151515;
}
.orange-button {
  font-family: Roboto;
  outline: 0;
  font-size: 1rem;
  font-weight: 500;
  background: #f36f2e;
  box-shadow: 0px 2px 2px rgb(0 0 0 / 12%);
  border: 1px solid #f36f2e;
  box-sizing: border-box;
  border-radius: 30px;
  color: white;
}
.scrollbar::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #f5f5f5;
}
.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #9c9c9c;
}
@media all and (max-width: 1100px) {
  .persona-container {
    .persona-added {
      width: 100%;
      .persona-detail-card {
        width: 38%;
        margin-right: 2%;
        .persona-detail-avatar {
          width: 100px;
          height: 100px;
        }
        .type {
          font-size: 1rem;
        }
        .title {
          font-size: 1.5rem;
        }
        .content {
          font-size: 0.875rem;
        }
      }
      .persona-detail-card::before {
        margin: 24% 34.5% 0 0;
        width: 15px;
        height: 15px;
      }
      .persona-detail-card::after {
        margin: 24% 0 0 34.5%;
        width: 15px;
        height: 15px;
      }
      .no-access-profile-filler::before {
        margin: 24% 37% 0 0;
      }
      .no-access-profile-filler::after {
        margin: 24% 0 0 37%;
      }
    }
  }
  .dialog-persona-container {
    width: 80vw;
    .dialog-title-container {
      height: 12%;
      padding: 4%;
    }
    .dialog-form-container {
      height: 88%;
      .title {
        font-size: 1.125rem;
        padding: 4%;
      }
      .answer-container {
        padding: 4%;
        .answer {
          .ans-item {
            margin: 0 2%;
          }
          .ans-item-label {
            font-size: 0.875rem;
          }
        }
      }
      .dialog-footer-container {
        padding: 4%;
      }
    }
  }
  .success-persona {
    width: 80vw;
    .cancel-success-persona {
      padding: 4%;
    }
  }
}
@media all and (max-width: 850px) {
  .persona-container {
    .persona-added {
      .persona-detail-card {
        width: 42%;
      }
      .persona-detail-card::before {
        margin: 25% 37.3% 0 0;
      }
      .persona-detail-card::after {
        margin: 25% 0 0 37.3%;
      }
      .no-access-profile-filler::before {
        margin: 25% 41% 0 0;
      }
      .no-access-profile-filler::after {
        margin: 25% 0 0 41%;
      }
    }
  }
}
@media all and (max-width: 700px) {
  .persona-container {
    align-items: center;
    padding-left: 0;
    .title-container {
      margin: 3% 0;
      width: 90%;
      .title {
        font-size: 1.25rem;
      }
      .utility {
        .span {
          font-size: 1.125rem;
        }
      }
    }
    .no-persona {
      margin: 3% 0;
      width: 90%;
      .sub-title {
        font-size: 1.125rem;
        font-weight: 500;
      }
      .orange-button {
        width: 70%;
        height: 25%;
      }
    }
    .persona-added {
      width: 90%;
      align-items: flex-end;
      margin: 0;
      .persona-detail-card {
        padding: 0 2%;
        width: 18rem;
        .title {
          font-size: 1.25rem;
        }
        .content {
          padding: 0 5%;
        }
      }
      .persona-detail-card:nth-of-type(3) {
        margin-right: 0;
      }
      .persona-detail-card::before {
        display: none;
      }
      .persona-detail-card::after {
        display: none;
      }
      .persona-detail-card:nth-of-type(1):before {
        display: initial;
        margin: 12rem 18.5rem 0 0;
        width: 10px;
        height: 10px;
      }
      .persona-detail-card:nth-of-type(1):after {
        display: initial;
        margin: 12rem 0 0 29.3rem;
        width: 10px;
        height: 10px;
      }
    }
  }
  .hide-scrollbar::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .hide-scrollbar::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  .dialog-persona-container {
    width: 100vw;
    height: 100vh;
    .dialog-title-container {
      height: 12%;
      padding: 6%;
    }
    .dialog-form-container {
      height: 88%;
      .title {
        font-size: 1.125rem;
        padding: 6%;
      }
      .answer-container {
        padding: 6%;
        height: 75%;
        .answer {
          flex-basis: 100%;
          height: 20%;
          .ans-item {
            margin: 0 3%;
          }
          .ans-item-label {
            font-size: 0.875rem;
          }
          .ans-item-label::before {
            content: "";
            margin-left: 12%;
          }
        }
      }
      .dialog-footer-container {
        height: 15%;
      }
    }
  }
  .success-persona {
    background: url("https://images.avishkaar.cc/misc/profile/images/success-image-mobile.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-color: #ffffff;
    background-position: center;
    width: 100vw;
    height: 100vh;
    .cancel-success-persona {
      padding: 5%;
    }
    div {
      margin-bottom: calc(7rem - 10%);
      padding: 1%;
      .success-title {
        font-size: 1.25rem;
      }
      .success-content {
        font-size: 0.875rem;
      }
    }
  }
  .persona-container-added {
    height: 85vh;
  }
}
</style>